export const BadgeStyle = {
  baseStyle: {
    borderRadius: '3xl',
  },
  sizes: {
    lg: {
      px: 3,
      py: 1,
    },
  },
};
